export const baseURL = `https://api.airtable.com/v0/${process.env.REACT_APP_AIRTABLE_BASE}`;

export const config = {
  headers: {
    'Authorization': `Bearer ${process.env.REACT_APP_AIRTABLE_KEY}`,
  },
};

export const travelEssentials = 'rec1Eryo3Yo4eccRI' 
export const fun = 'rec36z3Bts6kNDBtd'
export const sanitation ='rec99uAB2odRpAUrX'
export const pets ='recEEJimvqlD3FQnF'
export const escapeRoutes ='recKo8SYySYwo5G81'

export const sewage = 'recL8noiwDNDMq5ER'
export const food = 'recTEPNKp9gsByeIG'
export const comms = 'recfTGrtSIzcajRO8'
export const friends = 'recm2BBPkh18DOOpj'

export const music = 'recnkmrFujnvic5ba'
export const water = 'recrDUbZazqmuGbq7'
export const weapons = 'recv96WwmmcDMA73h'
export const shelters = 'recxptVX8Dq0AMXB4'
